import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { doTempUpdateAiSuggestions } from 'ducks/ai/operations'
import { selectCurrentTicketId } from 'selectors/tickets/current/selectCurrentTicketId'
import {
  selectSuggestionsIsLoading,
  selectSuggestionsIsLoaded,
  selectSuggestionForType,
  selectSuggestionsIsEmpty,
} from 'ducks/ai/selectors/suggestions'
import { Loader } from 'shared/ui'

import sparkles from 'assets/icons/emoji/sparkles.png'
import CollapsableCard from 'components/CollapsableCard'
import SortableVisibleControlsWithTitle from '../../../SortableVisibleControlsWithTitle'
import SuggestedTags from './SuggestedTags'
import Summary from './Summary'
import ReplyDraft from './ReplyDraft'
import Sentiment from './Sentiment'

import { styles } from './styles'

export default function Attachments({ doHideCard }) {
  const dispatch = useDispatch()
  const ticketId = useSelector(selectCurrentTicketId)

  const isLoading = useSelector(state =>
    selectSuggestionsIsLoading(state, ticketId)
  )
  const isLoaded = useSelector(state =>
    selectSuggestionsIsLoaded(state, ticketId)
  )
  const isEmpty = useSelector(state =>
    selectSuggestionsIsEmpty(state, ticketId)
  )
  const tagsSuggestion = useSelector(state =>
    selectSuggestionForType(state, ticketId, { type: 'tags' })
  )

  useEffect(
    () => {
      if (!isLoaded && !isLoading) {
        dispatch(doTempUpdateAiSuggestions({ ticketId }))
      }
    },
    [dispatch, isLoaded, isLoading, ticketId]
  )

  if (ticketId === 'new') {
    return null
  }

  return (
    <CollapsableCard
      persistenceKey={'customWidget.ai'}
      title={
        <SortableVisibleControlsWithTitle
          title={
            <>
              Groove AI <img src={sparkles} css={styles.icon} alt="" />
            </>
          }
          onHide={doHideCard}
        />
      }
      css={styles.card}
    >
      {isLoading && <Loader className="grui my-7" />}
      {isLoaded && isEmpty && <span>We are generating suggestions...</span>}
      {isLoaded && (
        <>
          <ReplyDraft />
          <Summary />
          <SuggestedTags ticketId={ticketId} suggestion={tagsSuggestion} />
          <Sentiment />
        </>
      )}
    </CollapsableCard>
  )
}
